import * as L from 'leaflet';
import { NTiledLayer } from './noneTileLayer'

export const NTiledLayerWMS = NTiledLayer.extend({
    defaultWmsParams: {
        service: 'WMS',
        request: 'GetMap',
        version: '1.1.1',
        layers: '',
        styles: '',
        format: 'image/jpeg',
        transparent: false
    },

    options: {
        crs: null,
        uppercase: false
    },

    initialize: function (url, options) { // (String, Object)
        this._wmsUrl = url;

        const wmsParams = L.extend({}, this.defaultWmsParams);

        // all keys that are not NonTiledLayer options go to WMS params
        for (const i in options) {
            if (!NTiledLayer.prototype.options.hasOwnProperty(i) &&
                !L.Layer.prototype.options.hasOwnProperty(i)) {
                wmsParams[i] = options[i];
            }
        }

        this.wmsParams = wmsParams;

        L.setOptions(this, options);
    },

    onAdd: function (map) {

        this._crs = this.options.crs || map.options.crs;
        this._wmsVersion = parseFloat(this.wmsParams.version);

        const projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
        this.wmsParams[projectionKey] = this._crs.code;

        NTiledLayer.prototype.onAdd.call(this, map);
    },

    getImageUrl: function (world1, world2, width, height) {
        const wmsParams = this.wmsParams;
        wmsParams.width = width;
        wmsParams.height = height;

        const nw = this._crs.project(world1);
        const se = this._crs.project(world2);

        const url = this._wmsUrl;

        const bbox = (this._wmsVersion >= 1.3 && this._crs === L.CRS.EPSG4326 ?
            [se.y, nw.x, nw.y, se.x] :
            [nw.x, se.y, se.x, nw.y]).join(',');

        return url +
            L.Util.getParamString(this.wmsParams, url, this.options.uppercase) +
            (this.options.uppercase ? '&BBOX=' : '&bbox=') + bbox;
    },

    setParams: function (params, noRedraw) {

        L.extend(this.wmsParams, params);

        if (!noRedraw) {
            this.redraw();
        }

        return this;
    }

});

export function nTileLayerWMS(url, options) {
    return new NTiledLayerWMS(url, options);
}